var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const GET_SET_ROUTES_ORDERS = 'api/routes/orders';
const GET_STORE_ROUTES = 'api/storeRoutes';
const GET_STORE_ROUTES_BY_ID = 'api/stores/:id/routes';
const GET_ROUTE = 'api/routes';
//@deprecated
export const getOrdersForRoute = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'store',
                'routeDate'
            ], params);
            return yield this.axiosInstance.get(`${GET_SET_ROUTES_ORDERS}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getOrdersForRoute:', error);
            throw error;
        }
    });
};
//@deprecated
export const getStoreRoutesList = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_STORE_ROUTES}/${storeId}`, config);
        }
        catch (error) {
            console.error('Error fetching getStoreRoutesList:', error);
            throw error;
        }
    });
};
//NEW V2 ENDPOINTS
export const getRoutesByStore = function (storeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_STORE_ROUTES_BY_ID.replace(':id', storeId)}`, config);
        }
        catch (error) {
            console.error('Error fetching getRoutesByStore:', error);
            throw error;
        }
    });
};
export const getRoutesByStorePage = function (storeId_1) {
    return __awaiter(this, arguments, void 0, function* (storeId, query = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'pageNum',
                'limit',
            ], query);
            return yield this.axiosInstance.get(`${GET_STORE_ROUTES_BY_ID.replace(':id', storeId)}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getRoutesByStorePage:', error);
            throw error;
        }
    });
};
export const getRouteByIdV2 = function (routeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_ROUTE}/${routeId}`, config);
        }
        catch (error) {
            console.error('Error fetching getRouteByIdV2:', error);
            throw error;
        }
    });
};
export const getClosePreview = function (routeId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${GET_ROUTE}/${routeId}/close-preview`, config);
        }
        catch (error) {
            console.error('Error fetching getClosePreview:', error);
            throw error;
        }
    });
};
export const getRoutesByDriver = function (query) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'status',
                'scope',
            ], Object.assign(Object.assign({}, query), { scope: "driver" }));
            return yield this.axiosInstance.get(`${GET_ROUTE}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getRoutesByDriver:', error);
            throw error;
        }
    });
};
export const getRoutes = function () {
    return __awaiter(this, arguments, void 0, function* (query = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'scope',
                'storeIds',
                'status',
                'driver',
                'createdFrom',
                'createdTo',
            ], query);
            return yield this.axiosInstance.get(`${GET_ROUTE}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getRoutes:', error);
            throw error;
        }
    });
};
export const getRoutesPage = function () {
    return __awaiter(this, arguments, void 0, function* (query = {}) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const queryParams = generateQueryParamsStr([
                'scope',
                'storeIds',
                'status',
                'driver',
                'createdFrom',
                'createdTo',
                'pageNum',
                'limit',
            ], query);
            return yield this.axiosInstance.get(`${GET_ROUTE}?${queryParams}`, config);
        }
        catch (error) {
            console.error('Error fetching getRoutesPage:', error);
            throw error;
        }
    });
};
